import { mapGetters } from 'vuex'

export default {
  name: 'EplNewPayNow',
  props: [],
  computed: {
    ...mapGetters(['paymentOptions'])
  },
  mounted () {
    this.$store.dispatch('getPaymentOptions')
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "REPAYMENT_OPTIONS"
    });
  },
  methods: {
    pay (paymentOption) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "REPAYMENT_OPTION_SELECTED",
        propertyName: "REPAYMENT_OPTION",
        propertyValue: paymentOption.type
      });
      this.$store.commit('setPaymentType', paymentOption.type)
      if (paymentOption.custom) {
        this.$router.push({ name: 'Pay Custom' })
      } else {
        localStorage.setItem('txnAmount', paymentOption.amount)
        this.$store.commit('setPaymentAmount', paymentOption.amount)
        this.$router.push({ name: 'Payment' })
        this.$store.dispatch("storeMixpanelEvent", {
          eventName: "REPAYMENT_OPTION_SELECTED",
          propertyName: "AMOUNT",
          propertyValue: paymentOption.amount
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/EplNewPayNow/component.js